export default [
  {
    key: 'name',
    label: '工事種別',
    style: {
    }
  }, 
  {
    key: 'code',
    label: '工事種別コード',
    style: {
    }
  },
  {
    key: 'actions',
    label: '',
    style: {
    }
  },
];


// WEBPACK FOOTER //
// ./src/containers/master/construction/listHeader.js